{
	"countries": {
		"US": { "url": "/l/us" }
	}
}
